import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { FaTwitter, FaFacebookF, FaRedditAlien, FaLink } from 'react-icons/fa';
import { Download, X } from 'lucide-react';
import { saveAs } from 'file-saver';

const ShareModal = ({ isOpen, onClose, imageData }) => {
  
  const shareToTwitter = () => {
    const text = encodeURIComponent('Check out this meme I made with MemeStudio! 🔥');
    window.open(`https://twitter.com/intent/tweet?text=${text}`, '_blank');
    toast.success('Opening Twitter...');
  };

  const shareToFacebook = () => {
    window.open('https://www.facebook.com/sharer/sharer.php', '_blank');
    toast.success('Opening Facebook...');
  };

  const shareToReddit = () => {
    const title = encodeURIComponent('Made this meme with MemeStudio');
    window.open(`https://www.reddit.com/submit?title=${title}`, '_blank');
    toast.success('Opening Reddit...');
  };

  const copyToClipboard = async () => {
    try {
      if (imageData) {
        // Convert data URL to blob
        const response = await fetch(imageData);
        const blob = await response.blob();
        await navigator.clipboard.write([
          new ClipboardItem({ 'image/png': blob })
        ]);
        toast.success('Image copied to clipboard!');
      }
    } catch (error) {
      // Fallback - some browsers don't support clipboard image
      toast.info('Download the image and share manually');
    }
  };

  const downloadImage = () => {
    if (imageData) {
      saveAs(imageData, 'meme.png');
      toast.success('Meme downloaded!');
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-[#18181b] border-[#27272a] text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-center font-['Space_Grotesk']">
            Share Your Meme
          </DialogTitle>
        </DialogHeader>

        {/* Preview */}
        {imageData && (
          <div className="relative bg-[#09090b] rounded-lg overflow-hidden mb-4">
            <img 
              src={imageData} 
              alt="Meme preview" 
              className="w-full h-auto max-h-64 object-contain"
            />
          </div>
        )}

        {/* Share Buttons */}
        <div className="grid grid-cols-2 gap-3">
          <Button
            onClick={shareToTwitter}
            className="share-btn share-btn-twitter"
            data-testid="share-twitter"
          >
            <FaTwitter className="w-5 h-5" />
            Twitter
          </Button>
          <Button
            onClick={shareToFacebook}
            className="share-btn share-btn-facebook"
            data-testid="share-facebook"
          >
            <FaFacebookF className="w-5 h-5" />
            Facebook
          </Button>
          <Button
            onClick={shareToReddit}
            className="share-btn share-btn-reddit"
            data-testid="share-reddit"
          >
            <FaRedditAlien className="w-5 h-5" />
            Reddit
          </Button>
          <Button
            onClick={copyToClipboard}
            className="share-btn bg-[#27272a] text-white hover:bg-[#3f3f46]"
            data-testid="copy-clipboard"
          >
            <FaLink className="w-5 h-5" />
            Copy
          </Button>
        </div>

        {/* Download Button */}
        <Button
          onClick={downloadImage}
          className="w-full mt-2 bg-[#bef264] text-black hover:bg-[#a3e635] font-medium"
          data-testid="modal-download-btn"
        >
          <Download className="w-4 h-4 mr-2" />
          Download Image
        </Button>

        <p className="text-center text-xs text-[#a1a1aa] mt-2">
          Tip: Download the meme first, then upload to your preferred platform for best quality
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default ShareModal;
